// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Hba-z","narrowOptionButtons":"Iba-z","noOptions":"Jba-z"};